import { ConfigCatProvider } from "configcat-react"
import { ContextProvider } from "context/_globals"
import "moment/locale/es"
import CreateRoutes from "routes/routes"
import { GlobalTokenSender } from "../common/context/GlobalTokenSender"
import UserIsAlreadyConnectedModal from "../common/modals/UserIsAlreadyConnectedModal"
import "./App.scss"

sessionStorage.removeItem("empresaActivaChanging")

const App = () => {
  // moment.locale("es")
  return (
    <ConfigCatProvider sdkKey={import.meta.env.REACT_APP_FLAG_PROTECTION_KEY}>
      <ContextProvider>
        <div className='App'>
          {/* @ts-expect-error TS(2746): This JSX tag's 'children' prop expects a single ch... */}
          <GlobalTokenSender>
            <CreateRoutes />
            <UserIsAlreadyConnectedModal />
          </GlobalTokenSender>
        </div>
      </ContextProvider>
    </ConfigCatProvider>
  )
}

export default App
